/* svnty-colour-rail.js: THE COLOR CAROUSEL (2026-09-25, 02:36 and 02:57). Phone only (under 750 px). The rail is a
 * native scroller and THE DOCK LENS is a scroll driven animation (svnty-colour-rail.css): no script while the finger moves.
 * Here: the layout (end pads, flat when all fit), the chosen color centered instantly on load, resize and re-render; a tap
 * (Trade's radio, natively) glides that bubble to the center, then THE RING draws itself clockwise from the top, the
 * bubble settles on a spring (1.34 to 1.28), the phone ticks at the tap; data-more-start/end; a script lens only where scroll
 * driven animations are missing. Reduced motion: no lens, no glide, no spring. No dependencies, no console. */
(function () {
  'use strict';
  if (window.SVNTY && window.SVNTY.crail) return;
  (window.SVNTY = window.SVNTY || {}).crail = true;

  var MQ = window.matchMedia('(max-width: 749px)');
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var SDA = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline: view()'));
  var W = 44, GAP = 12, POP = 0.28, FADE = 40, NS = 'http://www.w3.org/2000/svg';
  var SPRING = (function () {                /* a damped spring kicked once, sampled: peak 1.34 / 1.28, back to 1 */
    var out = [], x = 0, v = 1, dt = 0.26 / 15 / 8, i, j, m = 0;
    for (i = 0; i < 16; i += 1) { out.push(x); m = Math.max(m, x); for (j = 0; j < 8; j += 1) { v += (-520 * x - 24 * v) * dt; x += v * dt; } }
    return out.map(function (y, k) { return { transform: 'scale(' + (k === 15 ? 1 : 1 + (1.34 / 1.28 - 1) * y / m) + ')' }; });
  })();
  var list = [];
  var TICK = (function () { var i = document.createElement('input'); i.type = 'checkbox'; i.setAttribute('switch', ''); return 'switch' in i; })();
  var tickAt = 0;
  function stopUp(e) { e.stopPropagation(); }

  function Rail(f) {
    var r = this;
    this.f = f; f._crail = this;
    this.onScroll = function () { if (!r.frame) r.frame = requestAnimationFrame(function () { r.frame = 0; r.sync(); }); };
    this.onChange = function (e) { if (e.isTrusted) r.haptic(); r.changed(e.target); };
    this.onDown = function () { r.touched = true; };
    this.onEnd = function () { if (r.touched && navigator.vibrate) try { navigator.vibrate(4); } catch (x) {} };
    this.ro = new ResizeObserver(function () { if (r.on || r.first) { r.first = false; r.measure(); } });
    this.bind();
  }

  Rail.prototype.bind = function () {
    var f = this.f, sc = f.querySelector('.svnty-option__values');
    if (this.sc && this.sc !== sc) this.unbind();
    if (!sc) return;
    this.sc = sc;
    this.ins = Array.prototype.slice.call(sc.querySelectorAll('input[type="radio"]'));
    this.labs = this.ins.map(function (i) { return i.nextElementSibling; });
    this.labs.forEach(function (l) {
      if (!l || l.querySelector('.svnty-crail__ring')) return;
      var s = document.createElementNS(NS, 'svg'), c = document.createElementNS(NS, 'circle');
      s.setAttribute('class', 'svnty-crail__ring'); s.setAttribute('viewBox', '0 0 44 44'); s.setAttribute('aria-hidden', 'true');
      c.setAttribute('cx', '22'); c.setAttribute('cy', '22'); c.setAttribute('r', '21'); c.setAttribute('transform', 'rotate(-90 22 22)');
      s.appendChild(c); l.appendChild(s);
    });
    ['start', 'end'].forEach(function (k) {
      if (f.querySelector('.svnty-crail__fade--' + k)) return;
      var d = document.createElement('span'); d.className = 'svnty-crail__fade svnty-crail__fade--' + k; d.setAttribute('aria-hidden', 'true'); f.appendChild(d);
    });
    /* THE TICK: a hidden switch the phone answers with a real haptic when it toggles (no name: never submitted, never read) */
    if (TICK && !f.querySelector('.svnty-crail__tick')) {
      var lb = document.createElement('label'), sw = document.createElement('input');
      lb.className = 'svnty-crail__tick'; lb.setAttribute('aria-hidden', 'true');
      sw.type = 'checkbox'; sw.setAttribute('switch', ''); sw.tabIndex = -1;
      ['click', 'input', 'change'].forEach(function (k) { sw.addEventListener(k, stopUp); lb.addEventListener(k, stopUp); });
      lb.appendChild(sw); f.appendChild(lb);
    }
    this.tick = f.querySelector('.svnty-crail__tick');
    this.fs = f.querySelector('.svnty-crail__fade--start'); this.fe = f.querySelector('.svnty-crail__fade--end');
    if (this.bound) return;
    this.bound = true;
    sc.addEventListener('scroll', this.onScroll, { passive: true });
    sc.addEventListener('change', this.onChange);
    sc.addEventListener('pointerdown', this.onDown, { passive: true });
    sc.addEventListener('scrollend', this.onEnd);
    this.ro.observe(sc);
  };

  Rail.prototype.unbind = function () {
    var sc = this.sc; if (!sc || !this.bound) return;
    sc.removeEventListener('scroll', this.onScroll);
    sc.removeEventListener('change', this.onChange);
    sc.removeEventListener('pointerdown', this.onDown);
    sc.removeEventListener('scrollend', this.onEnd);
    this.ro.disconnect(); this.bound = false;
  };

  Rail.prototype.checked = function () {
    for (var i = 0; i < this.ins.length; i += 1) if (this.ins[i].checked) return i;
    return 0;
  };

  /* layout only (resize, load, re-render): the mode, the end pads, the bubble centers, the fades' box; then the chosen
     color at the center, instantly */
  Rail.prototype.measure = function () {
    var f = this.f, sc = this.sc, n = this.labs.length;
    if (!sc || !n) return;
    this.on = true;
    this.flat = n * W + (n - 1) * GAP <= f.clientWidth;
    f.setAttribute('data-crail', this.flat ? 'flat' : 'rail');
    var cw = sc.clientWidth;
    sc.style.setProperty('--crail-pad', (cw / 2 - W / 2) + 'px');
    f.style.setProperty('--crail-top', sc.offsetTop + 'px');
    f.style.setProperty('--crail-h', sc.offsetHeight + 'px');
    /* A-09 (D5-1): under dir="rtl" the rail starts at the right and scrollLeft runs negative; every position here is the
       LOGICAL one (0 at the inline start, growing toward the end), so centres are measured from the right edge */
    this.rtl = getComputedStyle(sc).direction === 'rtl';
    var sr = sc.getBoundingClientRect(), p = this.pos(), rtl = this.rtl;
    this.cw = cw;
    this.c = this.labs.map(function (l) { var b = l.getBoundingClientRect(); return rtl ? sr.right - (b.left + b.width / 2) + p : b.left + b.width / 2 - sr.left - sc.clientLeft + p; });
    this.max = Math.max(0, sc.scrollWidth - cw);
    this.want = this.checked();
    this.go(this.want, false);
    this.sync();
  };

  /* the logical scroll position: 0 at the inline start in either direction */
  Rail.prototype.pos = function () { return this.rtl ? Math.abs(this.sc.scrollLeft) : this.sc.scrollLeft; };

  Rail.prototype.snap = function (i) { return Math.min(this.max, Math.max(0, this.c[i] - this.cw / 2)); };

  /* the chosen bubble to the center: instantly (layout, re-render, reduced motion) or a smooth glide (a tap, the keys) */
  Rail.prototype.go = function (i, smooth) {
    if (this.flat) { if (this.sc.scrollLeft) this.sc.scrollLeft = 0; return; }
    var to = this.snap(i), left = this.rtl ? -to : to;
    if (smooth && !RM.matches) this.sc.scrollTo({ left: left, behavior: 'smooth' });
    else this.sc.scrollLeft = left;
  };

  /* data-more-* always; the fades and the lens from here only where scroll driven animations are missing */
  Rail.prototype.sync = function () {
    var p = this.pos(), a = !this.flat && p > 0.5, b = !this.flat && this.max - p > 0.5;
    if (a !== this.ms) this.f.toggleAttribute('data-more-start', this.ms = a);
    if (b !== this.me) this.f.toggleAttribute('data-more-end', this.me = b);
    if (SDA || this.flat) return;
    if (this.fs) { this.fs.style.opacity = Math.min(1, p / FADE); this.fe.style.opacity = Math.min(1, (this.max - p) / FADE); }
    if (RM.matches) return;
    var mid = p + this.cw / 2, P = W + GAP;
    for (var i = 0; i < this.labs.length; i += 1) {
      var u = Math.abs(this.c[i] - mid) / P;
      this.labs[i].style.scale = u >= 2 ? '' : String(Math.round((1 + POP * 0.5 * (1 + Math.cos(Math.PI * u / 2))) * 1000) / 1000);
    }
  };

  /* a change of Trade's radio (a tap, the keys, the sticky bar, the bus): glide it to the center, then the signature */
  Rail.prototype.changed = function (t) {
    var i = this.ins.indexOf(t), r = this, l = this.labs[i];
    if (i < 0 || !this.on || !l) return;
    this.want = i;
    if (this.flat || RM.matches) { this.go(i, false); this.pop(i); return; }
    var to = this.snap(i), t0 = performance.now();
    if (Math.abs(this.pos() - to) < 1) { this.pop(i); return; }
    l.classList.add('is-crail-pending');
    this.go(i, true);
    cancelAnimationFrame(this.wait);
    this.wait = requestAnimationFrame(function look(now) {
      if (r.want !== i) { l.classList.remove('is-crail-pending'); return; }
      if (Math.abs(r.pos() - to) < 1 || now - t0 > 700) { r.pop(i); return; }
      r.wait = requestAnimationFrame(look);
    });
  };

  /* one haptic tick inside the tap's own event (the phone grants it only there), at most every 120 ms; never on a scroll */
  Rail.prototype.haptic = function () {
    if (!this.tick || !this.on || performance.now() - tickAt < 120) return;
    tickAt = performance.now(); this.tick.click(); this.tick.firstChild.checked = false;
  };

  /* THE SIGNATURE: the ring draws itself clockwise from the top, the disc and the ring settle with a spring */
  Rail.prototype.pop = function (i) {
    var l = this.labs[i]; if (!l) return;
    var had = l.classList.contains('is-crail-pending') || this.flat;
    l.classList.remove('is-crail-pending');
    if (RM.matches || !l.animate) return;
    var ring = l.querySelector('.svnty-crail__ring'), fill = l.querySelector('.svnty-bubble__fill');
    try {
      [ring, fill].forEach(function (el) { if (el) el.animate(SPRING, { duration: 260, easing: 'linear' }); });
      if (had && ring) ring.firstChild.animate([{ strokeDashoffset: '132px' }, { strokeDashoffset: '0px' }], { duration: 220, easing: 'cubic-bezier(0.3, 0.6, 0.2, 1)' });
    } catch (e) {}
  };

  Rail.prototype.off = function () {
    this.on = false; cancelAnimationFrame(this.wait);
    this.f.removeAttribute('data-crail'); this.f.removeAttribute('data-more-start'); this.f.removeAttribute('data-more-end');
    this.ms = this.me = undefined;
    if (this.sc) this.sc.style.removeProperty('--crail-pad');
    (this.labs || []).forEach(function (l) { l.style.scale = ''; l.classList.remove('is-crail-pending'); });
    if (this.fs) { this.fs.style.opacity = ''; this.fe.style.opacity = ''; }
  };

  /* every color fieldset on the page, including one that Trade or a quick-add modal has just rendered. P17-24 (PERF_A11Y P2-6):
     a rail that lands with the DOOR (from the observer, inside quick-add-modal) takes its first measure in its ResizeObserver's
     first callback, after the browser's own layout and before the paint, never inside the tap that wrote it: measuring in the
     observer's microtask forced a layout of the whole door (9 to 12 ms of the tap at 4x CPU, measured on the preview at 393).
     The product page's own re-render keeps its measure in the same frame (swatch guard S5: attached in the first frame). */
  function scan(lazy) {
    list = list.filter(function (r) { return r.f.isConnected; });
    if (!MQ.matches) return;
    var fs = document.querySelectorAll('fieldset.svnty-crail');
    for (var i = 0; i < fs.length; i += 1) {
      var f = fs[i], r = f._crail;
      if (!r) { r = new Rail(f); list.push(r); if (lazy && r.sc && f.closest('quick-add-modal')) r.first = true; else r.measure(); continue; }
      if (f.querySelector('.svnty-option__values') !== r.sc || (r.labs[0] && !r.labs[0].isConnected) || !f.querySelector('.svnty-crail__ring')) { r.bind(); r.measure(); }
    }
  }

  function mode() {
    if (MQ.matches) { list.forEach(function (r) { r.bind(); r.measure(); }); scan(); }
    else list.forEach(function (r) { r.off(); });
  }

  function start() {
    scan();
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i += 1) {
        var a = ms[i].addedNodes;
        for (var j = 0; j < a.length; j += 1) if (a[j].nodeType === 1) { scan(true); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
    if (MQ.addEventListener) MQ.addEventListener('change', mode); else MQ.addListener(mode);
    if (RM.addEventListener) RM.addEventListener('change', function () { list.forEach(function (r) { if (r.on) r.measure(); }); });
    /* the color bus: a color chosen elsewhere that did not pass through this rail's change */
    document.addEventListener('svnty:colour', function () {
      list.forEach(function (r) { if (r.on && r.want !== r.checked()) r.changed(r.ins[r.checked()]); });
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { list.forEach(function (r) { if (r.on) r.measure(); }); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
